import * as types from './types'
import { toast } from 'react-toastify'
import moment from 'moment'
import { createAxiosInstance } from '../utils/helpers'
import { API_URL } from '.'
import history from '../utils/history'
import { displayMessages, uploadFiles } from './common'


export function initReducer() {
	return (dispatch) => {
		dispatch({ type: types.REINICIAR_SOLICITUD_HOTELES })
	}
}


export function updateInputs(path, value) {
    if(path === 'motivo_hospedaje' || path === 'observaciones' || path.includes('huespedes') || path.includes('ciudad')){
        const regex = /[!@#$%^&*()_+\[\]{}|;':",.<>?´áéíóúÁÉÍÓÚ¡]/g;
        value = value.replace(regex, "").toUpperCase();
    }

	return (dispatch) => {
		dispatch({ type: types.MODIFICAR_INPUTS_SOLICITUD_HOTELES, payload: { path, value } })
	}
}


export function addAlojamiento() {
	return (dispatch) => {
		dispatch({ type: types.ADICIONAR_ALOJAMIENTO })
	}
}


export function removeAlojamientos() {
	return (dispatch) => {
		dispatch({ type: types.REMOVER_ALOJAMIENTOS })
	}
}


export function createSolicitudHoteles() {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {

		const fn0 = (d) => d({ type: types.DESHABILITAR_BOTON_GUARDAR_SOLICITUD_HOTELES, payload: true })
		const fn1 = (d) => d({ type: types.DESHABILITAR_BOTON_GUARDAR_SOLICITUD_HOTELES, payload: false })
		const fn2 = (d) => d(initReducer())
		fn0(dispatch)

		const data = getState().creacionsolicitudhoteles
        const files = data.get('adjuntos')

		axios.post(`${API_URL}/solicitudes/hoteles`, data)
		.then(res => {

			const fn3 = () => history.push(window.FOLDER + '/solicitudes/abiertas');
			const fn4 = () => toast.success('La solicitud ha sido guardada exitosamente', { bodyClassName: 'toastify-content toastify-success' })
			dispatch(uploadFiles(`/files/${res.data.solicitud.id}`, files, [fn1, fn2, fn3, fn4]))

			fn1(dispatch);
			fn2(dispatch);
			fn3();
			fn4();


		})
		.catch(err => {
			displayMessages(dispatch, err)
			fn1(dispatch)
		})



	}
}

export function addHuesped(payload) {
	return (dispatch, getState) => {
		const path = payload.path.split('.')[0]
		const huespedes = getState().creacionsolicitudhoteles.get(path)
		if (huespedes.filter(x => x.get('id') === payload.value.id).count() !== 0) {
			toast.warn(`La persona ${payload.value.fullname} ya se encuentra en el listado`, { bodyClassName: 'toastify-content toastify-warning' })
		} else {
			let huesped = getState().creacionsolicitudhoteles.getIn(payload.path.split('.')).toJS()
			huesped = {...huesped, ...payload.value}
			huesped.correo = huesped.email
			huesped.cedula = huesped.username
			payload.value = huesped
			dispatch({ type: types.ADICIONAR_ELEMENTO_LISTA_SOLICITUD_HOTELES, payload })
		}
	}
}



export function addCencoSolicitud() {
	return (dispatch) => {
		dispatch({ type: types.ADICIONAR_NUEVO_CENCO_SOLICITUD_HOTELES })
	}
}


export function removeCenco() {
	return (dispatch) => {
		dispatch({ type: types.REMOVER_CENCOS_HOTELES })
	}
}

export function enviarComentario() {
	return (dispatch, getState) => {
		const guid = getState().creacionsolicitudhoteles.getIn(['comentario', 'guid'])
		const comentario = getState().creacionsolicitudhoteles.getIn(['comentario', 'texto'])
		const usuario = getState().common.get('user')
		const fn1 = (d) => d({ type: types.ENVIAR_COMENTARIO_SOLICITUD_HOTELES, payload: {comentario, guid , usuario} })
		fn1(dispatch)
	}
}

export function editarComentario(guid) {
	return (dispatch) => {
		const fn1 = (d) => d({ type: types.EDITAR_COMENTARIO_SOLICITUD_HOTELES, payload: {guid} })
		fn1(dispatch)
	}
}

export function eliminarComentario(guid) {
	return (dispatch) => {
		const fn1 = (d) => d({ type: types.ELIMINAR_COMENTARIO_SOLICITUD_HOTELES, payload: { guid } })
		fn1(dispatch)
	}
}

export function addFile(){
    return (dispatch, getState) => {
        const data = getState().common.getIn(['modalAddFile', 'data'])
		const errors = []
		if (!data.get('file')) errors.push('No adicionó ningun archivo')
		if (!data.get('clasificacion')) errors.push('No se seleccionó ninguna clasificación')
		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
		} else {
			const fn1 = (d) => d({ type: types.ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_HOTELES1, payload: data })
			const fn2 = (d) => d({ type: types.OCULTAR_MODAL_AGREGAR_ARCHIVO })
			fn1(dispatch)
			fn2(dispatch)
		}
	}
}

export function removeSolicitudHotelesFiles() {
	return (dispatch) => {
		dispatch({ type: types.ELIMINAR_ARCHIVOS_SOLICITUD_HOTELES })
	}
}








// WEBPACK FOOTER //
// ./src/actions/creacionsolicitudhoteles.js